import { useSections } from "@/i18n/detect";

const Capabilities = () => {
  const t = useSections().capabilities;

  return (
    <section className="py-24">
      <div className="container">
        <div className="mx-auto max-w-3xl text-center">
          <span className="text-sm font-semibold uppercase tracking-widest text-primary">
            {t.eyebrow}
          </span>
          <h2 className="mt-3 font-display text-4xl font-bold text-secondary md:text-5xl">
            {t.title}
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">{t.subtitle}</p>
        </div>

        <div className="mt-16 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {t.items.map((c) => (
            <div
              key={c.title}
              className="rounded-2xl border border-border bg-card p-7 shadow-card transition-all hover:-translate-y-1 hover:border-primary/30 hover:shadow-elegant"
            >
              <h3 className="font-display text-xl font-bold text-secondary">{c.title}</h3>
              <p className="mt-3 text-muted-foreground">{c.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Capabilities;
